module.exports = __webpack_public_path__ + "media/images/sp/stores/nagoya_ekimae/nagoya_ekimae_sns_03-a1f1c5cd6b57ba7a054a70a44025d89d.jpg";